/* IMA Select – Warenkorb-Leiste, Filter, Suche, Sortierung */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (window.IMA && window.IMA.root) || '/';
  const url = p => (root.endsWith('/') ? root : root + '/') + p;
  const SECTION = 'ima-cart-drawer';

  /* ---------- Toast ---------- */
  function toast(msg) {
    const t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(() => (t.hidden = true), 2200);
  }

  /* ---------- Warenkorb-Leiste ---------- */
  const drawer = $('[data-drawer]'), overlay = $('[data-overlay]');
  function openCart() {
    if (!drawer) return;
    overlay.hidden = false; drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    const c = drawer.querySelector('[data-close-cart]'); if (c) c.focus();
  }
  function closeCart() {
    if (!drawer) return;
    overlay.hidden = true; drawer.hidden = true;
    document.documentElement.style.overflow = '';
  }
  function applySections(sections) {
    if (!sections || !sections[SECTION] || !drawer) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = sections[SECTION];
    const inner = tmp.querySelector('.ima-drawer-inner');
    const target = drawer.querySelector('.ima-drawer-inner');
    if (inner && target) target.replaceWith(inner);
    const count = inner ? inner.dataset.count : null;
    if (count != null) $$('[data-cart-count]').forEach(el => (el.textContent = count));
  }
  async function refreshCart() {
    const r = await fetch(url('?sections=' + SECTION), { headers: { Accept: 'application/json' } });
    if (r.ok) applySections(await r.json());
  }
  async function addToCart(id, qty, name) {
    const r = await fetch(url('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }], sections: SECTION })
    });
    const data = await r.json();
    if (!r.ok) { toast(data.description || data.message || 'Konnte nicht hinzugefügt werden'); return false; }
    applySections(data.sections);
    toast((name || 'Artikel') + ' liegt im Warenkorb');
    return true;
  }
  async function changeLine(line, qty) {
    drawer && drawer.classList.add('is-busy');
    try {
      const r = await fetch(url('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(qty), sections: SECTION })
      });
      const data = await r.json();
      if (!r.ok) toast(data.description || data.message || 'Fehler');
      else applySections(data.sections);
    } finally { drawer && drawer.classList.remove('is-busy'); }
  }

  document.addEventListener('click', e => {
    const open = e.target.closest('[data-open-cart]');
    if (open && drawer && !document.body.classList.contains('template-cart')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-close-cart]')) {
      const a = e.target.closest('a[data-close-cart]');
      closeCart();
      if (!a) e.preventDefault();
      return;
    }
    if (e.target === overlay) { closeCart(); return; }
    const q = e.target.closest('[data-drawer] [data-line]');
    if (q) { e.preventDefault(); changeLine(q.dataset.line, q.dataset.qty); return; }
    const add = e.target.closest('[data-add]');
    if (add) {
      e.preventDefault();
      add.disabled = true;
      addToCart(add.dataset.add, 1, add.dataset.name).finally(() => (add.disabled = false));
    }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  /* ---------- Produktseite ---------- */
  const pform = $('[data-product-form]');
  if (pform) {
    const sel = $('select[data-variant]', pform), qty = $('[data-qty]', pform);
    const btn = $('button[type=submit]', pform), priceEl = $('[data-price]');
    $$('[data-step]', pform).forEach(b => b.addEventListener('click', () => {
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.step));
    }));
    if (sel) sel.addEventListener('change', () => {
      const o = sel.selectedOptions[0];
      priceEl.innerHTML = o.dataset.price + (o.dataset.compare ? '<s>' + o.dataset.compare + '</s>' : '');
      const ok = o.dataset.available === 'true';
      btn.disabled = !ok; btn.textContent = ok ? 'In den Warenkorb' : 'Ausverkauft';
      const u = new URL(location.href); u.searchParams.set('variant', o.value); history.replaceState(null, '', u);
    });
    pform.addEventListener('submit', async e => {
      e.preventDefault();
      const id = (sel || $('[data-variant]', pform)).value;
      btn.disabled = true;
      const ok = await addToCart(id, parseInt(qty.value, 10) || 1, btn.dataset.name);
      btn.disabled = false;
      if (ok) openCart();
    });
    $$('.pdp-thumbs button').forEach(b => b.addEventListener('click', () => {
      const img = $('[data-gallery] img');
      if (img) { img.src = b.dataset.img; img.removeAttribute('srcset'); }
      $$('.pdp-thumbs button').forEach(x => x.setAttribute('aria-current', x === b));
    }));
  }

  /* ---------- Filter, Suche, Sortierung ---------- */
  $$('[data-shop]').forEach(shop => {
    const grid = $('[data-grid]', shop); if (!grid) return;
    const cards = $$('.card', grid), empty = $('[data-empty]', grid);
    const state = { cat: 'Alle', q: '', sort: 'pop' };
    function render() {
      let shown = 0;
      cards.forEach(c => {
        const ok = (state.cat === 'Alle' || c.dataset.type === state.cat) && (!state.q || c.dataset.text.includes(state.q));
        c.hidden = !ok; if (ok) shown++;
      });
      const s = state.sort;
      const sorted = cards.slice().sort((a, b) =>
        s === 'asc' ? a.dataset.price - b.dataset.price :
        s === 'desc' ? b.dataset.price - a.dataset.price :
        s === 'new' ? (b.dataset.new - a.dataset.new) || (b.dataset.created - a.dataset.created) :
        a.dataset.pos - b.dataset.pos);
      sorted.forEach(c => grid.insertBefore(c, empty));
      if (empty) empty.hidden = shown > 0 || !cards.length;
    }
    $$('.chip[data-cat]', shop).forEach(b => b.addEventListener('click', () => {
      state.cat = b.dataset.cat;
      $$('.chip[data-cat]', shop).forEach(x => x.setAttribute('aria-pressed', x === b));
      render();
    }));
    const search = $('[data-search]', shop), sort = $('[data-sort]', shop);
    if (search) search.addEventListener('input', () => { state.q = search.value.trim().toLowerCase(); render(); });
    if (sort) sort.addEventListener('change', () => { state.sort = sort.value; render(); });
  });

  /* Nach "Zurück" aus dem Bezahlvorgang Warenkorb aktualisieren */
  window.addEventListener('pageshow', e => { if (e.persisted) refreshCart(); });
})();
